import { _ } from "../../core/polyglot/polyglot.js";
import navigationWidget from "../../core/chrome/navigationWidget.js";
import PerfectScrollbar from "perfect-scrollbar";
import session from "../../core/session.js";
import theme from "../../core/theme.js";

/**
 * `accountingNavigationWidget` renders the avatar card (or
 * link to the agency) on the bottom of the navigation.
 */
function accountingNavigationWidget(spec, my) {
	spec ||= {};
	my ||= {};

	const that = navigationWidget(spec, my);
	const hideAvatar = spec.hideAvatar;

	let container;

	/**
	 * Adjust the position of the avatar depending on a
	 * possible overflow.
	 */

	that.checkAvatarOverflow = function () {
		const height = that.asJQuery().find(".leftmenu-container").height();
		const backToAgency = that.asJQuery().find(".avatar-tile");

		// Remove the overflowing property first to compute the
		// final height without the backToAgency li floating in
		// the navigation
		backToAgency.removeClass("overflowing");
		hideMoreTile();

		const backToAgencyHeight = backToAgency.height();
		const navigationHeight = that.asJQuery().find(".leftmenu").height();

		if (height < navigationHeight + backToAgencyHeight) {
			backToAgency.addClass("overflowing");
			showMoreTile();
		}
	};

	/**
	 * We listen for clicks and window resize events to know when
	 * there is an overflow with the consultant in the
	 * navigation.
	 *
	 * When there is, the consultant list item will become
	 * relatively positioned so that it stays in the bottom, and
	 * the "push" list item's height will be reduced to 0px.
	 */
	that.onIconModeToggled.register(that.checkAvatarOverflow);
	window.addEventListener("resize", that.checkAvatarOverflow);

	that.renderContentOn = function (html) {
		if (!my.visible) {
			return;
		}

		container = html.div(
			{ class: [my.cssClass(), { "lm-small": my.isIconMode }] },
			html.ul(
				{ class: "leftmenu" },
				my.renderVisibleNavigationItemsOn,
				my.renderMoreTileOn,
				html.li({ class: "push" }),
				my.renderAvatarOn,
			),
		);

		my.checkForTouchDevice(container);
		container.click(that.checkAvatarOverflow);
	};

	my.didAttach = function () {
		if (container) {
			// eslint-disable-next-line sonarjs/constructor-for-side-effects -- don't want to change that now
			new PerfectScrollbar(container.element);
		}
		that.checkAvatarOverflow();
	};

	that.show = function () {
		my.visible = true;
		that.update();
	};

	that.hide = function () {
		my.visible = false;
		that.update();
	};

	my.renderMoreTileOn = function (html) {
		html.li(
			{ klass: "lm-li-item more-tile" },
			html
				.a({
					klass: "menu-more-sm",
				})
				.click(that.toggleIconMode),
		);
	};

	my.renderAvatarOn = function (html) {
		if (hideAvatar) {
			return;
		}
		const user = session.getCurrentUser();
		if (theme.hasBackToAgencySettings()) {
			my.renderCustomBackToAgencyOn(html);
		} else if (user.isAgencyUser()) {
			my.renderBackToAgencyOn(html);
		} else {
			my.renderBrandedAvatarOn(html);
		}
	};

	my.renderCustomBackToAgencyOn = function (html) {
		const backToAgencyUrl = session.agency.homepage;
		const backToAgencyIcon = theme.backToAgencyIcon || theme.agencyLogo;
		if (backToAgencyUrl) {
			html.li(
				{
					class: "avatar-tile leftmenu-consultant clickable back-to-agency",
				},
				html.a({ class: "back-to-agency-link", href: backToAgencyUrl }),
				html.a(
					{ href: backToAgencyUrl, "data-test": "back-to-agency" },
					html.div(
						{ class: "back-to-agency-custom-icon" },
						html.img({ src: backToAgencyIcon }),
					),
					html.strong(
						{ class: "back-to-agency-label" },
						theme.backToAgencyLabel,
					),
				),
			);
		} else {
			html.li(
				{
					class: "avatar-tile leftmenu-consultant clickable back-to-agency",
				},
				html.span({ class: "back-to-agency-link" }),
				html.span(
					html.div(
						{ class: "back-to-agency-custom-icon" },
						html.img({ src: backToAgencyIcon }),
					),
					html.strong(
						{ class: "back-to-agency-label" },
						theme.backToAgencyLabel,
					),
				),
			);
		}
	};

	my.renderBackToAgencyOn = function (html) {
		html.li(
			{
				class: "avatar-tile leftmenu-consultant clickable back-to-agency",
			},
			html.a(
				{
					class: "back-to-agency-link",
					href: session.navigationLinks.myCompanies,
				},
				html.div({ class: "back-to-agency-arrow" }),
				_("Back to agency"),
			),
			html.a(
				{ href: session.navigationLinks.myCompanies },
				html.div(
					{ class: "back-to-agency-icon" },
					html.img({ src: theme.agencyLogo }),
				),
				html.strong(
					{ class: "back-to-agency-label" },
					session.agency.name,
				),
			),
		);
	};

	my.renderBrandedAvatarOn = function (html) {
		html.li(
			{ class: "avatar-tile leftmenu-consultant" },
			html.h2({ class: "menu-title" }, html.span(_("My agency"))),
			html.div(
				{ class: "back-to-agency-icon" },
				html.img({ src: theme.agencyLogo }),
			),
			html.strong(session.agency.name),
		);
	};

	my.isItemVisible = function (item) {
		// Todo: use a super call when using klassified
		return (
			my.navigationIsItemVisible(item) &&
			session
				.getCurrentUser()
				.hasCompanyRole(item.roles, session.getCompany().getLegacyId())
		);
	};

	function hideMoreTile() {
		const showMoreItem = that.asJQuery().find(".more-tile");
		showMoreItem.removeClass("overflowing");
	}

	function showMoreTile() {
		const showMoreItem = that.asJQuery().find(".more-tile");

		// The height of the tile is the normal height (50px, and 1px of
		// border), plus the height of the part that could be seen of the
		// last half-visible icon to make sure we do not have half-visible
		// menu icons.
		const height =
			50 +
			(that.asJQuery().find(".leftmenu-container").height() % 51) -
			1;

		showMoreItem.addClass("overflowing");
		showMoreItem.height(`${height}px`);
	}

	return that;
}

export default accountingNavigationWidget;
